import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../@types/ErrorHandling'
import { FillDataForSimulationClientResponse } from '../../@types/fillDataForSimulation'
import { ENV } from '../../Environment'
import { api } from '../../Services/API'
import { useFillDataForSimulationStore } from '../../Stores/useFillDataForSimulationStore'
import { API_ROUTES } from '../../constants/apiRoutes'
import { useErrorRequest } from '../useErrorRequest'

const headers = {
  'aip-company': ENV().FillDataForSimulation.Company,
  'aip-channel': ENV().FillDataForSimulation.Channel,
}

const request = async (agentCode: string) => {
  const { data } = await api.post<FillDataForSimulationClientResponse>(
    API_ROUTES.fillDataForSimulation,
    { agentCode },
    {
      headers,
    },
  )

  return data
}

export const useFillDataForSimulation = () => {
  const { setFillDataForSimulationRequest } = useFillDataForSimulationStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (agentCode: string) => request(agentCode),
    onSuccess: (data) => {
      setFillDataForSimulationRequest(data)
    },
    onError: (error: AxiosError<ErrorHandling[]>) => {
      handleErrorRequest({ error })
    },
  })
}
